

















import {Component, Vue} from 'vue-property-decorator';
import {DrunkardWalkStrategy} from '../ts/DrunkardWalkStrategy';
import {GridFacade} from '../ts/GridFacade';
import {ProgressBar} from '../ts/ProgressBar';
import {Preset, Presets} from '../ts/Presets';

@Component
export default class Generator extends Vue {

    private timerId: number = 0;

    private generate(preset: Preset) {
        clearTimeout(this.timerId);

        const canvas = document.getElementById('canvas') as HTMLCanvasElement;

        const rows = canvas.width / preset.cellSize;
        const columns = canvas.height / preset.cellSize;

        const gridFacade = new GridFacade(canvas, preset.cellSize, preset.wallSize, preset.pathBorderProbabilities);

        const targetCells = rows * columns * preset.fillFactor;

        const pathStrategy = new DrunkardWalkStrategy(rows, columns, preset.corridorBias, preset.centerBias);

        const progressBar = new ProgressBar(document.getElementById('progressBar') as HTMLCanvasElement);

        this.timerId = setInterval(() => {
            for (let i = 0; i < preset.iterationsPerFrame; i++) {
                const origin = pathStrategy.nextCell();
                gridFacade.drawPathAt(origin);
                progressBar.updateProgress(gridFacade.reachableCellsAmount(), targetCells);
                if (gridFacade.reachableCellsAmount() >= targetCells) {
                    clearTimeout(this.timerId);
                }
            }

        }, 1);
    }

    private presets() {
        return Presets;
    }

    private mounted() {
        this.generate(Presets.OrganicBasic);
    }

}
